import React, {useContext, useEffect, useState, useMemo} from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import { Context } from "../../commons/context";
import Button from '../_shared/Button';
import loader from "../_shared/Loader";
import LoaderBig from '../_shared/LoaderBig';
import JwtInterceptor from '../_shared/JwtInterceptors';
import AuthContext from "../_shared/AuthContext";
import team from "../Team/Team";

const API_URL = process.env.REACT_APP_API_URL;

const CompetitionPrizeDivisionPopUp = ({ setPrizesPopUp, editionId }) => {
  const { t } = useTranslation();
  const { register, handleSubmit, watch, reset, setValue, getValues, formState: { errors } } = useForm();
  const { logout } = useContext(AuthContext);
  const [data] = useContext(Context);
  const [disabledButton, setDisabledButton] = useState(false);
  const [getData, setGetData] = useState({});
  const [loader, setLoader] = useState(true);
  const [sendLoader, setSendLoader] = useState(false);
  const [totalPrize, setTotalPrize] = useState();
  const [resultId, setResultId] = useState();
  const [error, setError] = useState(false);
  const [sendError, setSendError] = useState(false);
  const [sendErrorTxt, setSendErrorTxt] = useState('');
  let fieldsets;
  let sum = 0;

  useEffect(() => {
    window.scrollTo(0, 0);
    setError(false);

    JwtInterceptor
        .get(`${API_URL}Competitions/edition/${editionId}/prize/${data.user.service.id}`)
        .then((response) => {
          setGetData(response.data.usersPrizes);
          setTotalPrize(response.data.totalPrize);
          setResultId(response.data.resultId);
          setLoader(false);
        })
        .catch(function (error) {
          setLoader(false);
          setError(true);
          if (error.response.status === 401) {
            logout();
          }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (getData && getData.length > 0) {
      const defaultFormValues = {};

      getData.forEach(field => {
        defaultFormValues[`prizeValue_${field.id}`] = field.prizeValue.toFixed(2).replace('.', ',');
        defaultFormValues[`prizePercent_${field.id}`] = 0;
      });
      reset(defaultFormValues);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getData, reset]);

  const prizeValueFields = useMemo(() => {
    if (getData && getData.length > 0) getData.map(field => `prizeValue_${field.id}`)
  }, [getData]);

  const watchedValues = watch(prizeValueFields);

  useEffect(() => {
    if (totalPrize && totalPrize > 0 && watchedValues) {
      for (const key in watchedValues) {
        if (key.startsWith('prizeValue_')) {
          const userId = key.split('_')[1];
          const value = String(watchedValues[key] || '0').replace(',', '.');
          const numericValue = parseFloat(value) || 0;
          let newPercentage = 0;

          if (numericValue > 0) {
            newPercentage = Math.round((numericValue / totalPrize) * 100);
          }

          const percentFieldName = `prizePercent_${userId}`;
          const currentPercentage = getValues(percentFieldName);

          if (Number(currentPercentage) !== newPercentage) {
            setValue(percentFieldName, newPercentage);
          }
        }
      }
    }
  }, [watchedValues, totalPrize, setValue, getValues]);

  const totalSum = useMemo(() => {
    let sum = 0;

    for (const key in watchedValues) {
      if (key.startsWith('prizeValue_')) {
        const value = watchedValues[key] ? String(watchedValues[key]).replace(',', '.') : '0';
        sum += parseFloat(value) || 0;
      }
    }

    return sum.toFixed(2);
  }, [watchedValues]);

  useEffect(() => {
    if (totalPrize < totalSum) {
      setDisabledButton(true);
    } else {
      setDisabledButton(false);
    }
  }, [totalPrize, totalSum]);

  const onSubmit = (formData) => {
    const teamIDs = {};
    const putObj = {
      "editionId": editionId,
      "resultId": resultId,
      "totalPrize": totalPrize,
      "usersPrizes": []
    };

    if (disabledButton) return;

    setSendLoader(true);
    setSendError(false);

    if (totalPrize - totalSum > 0) {
      setSendErrorTxt(t('Prosimy rozdzielić całą wartość nagrody'));
      setSendError(true);
      setSendLoader(false);
      return;
    }

    for (const key in formData) {
      if (key.startsWith("prizeValue_")) {
        teamIDs[key] = formData[key];
      }
    }

    for (const key in teamIDs) {
      if (Object.prototype.hasOwnProperty.call(teamIDs, key)) {
        const k = key.substring(11);
        const v = teamIDs[key];
        const user = getData.filter(row => row.id === Number(k));

        putObj.usersPrizes.push({
          "prizeValue": Number(v.replace(',', '.')),
          "id": user[0].id,
          "firstName": user[0].firstName,
          "lastName": user[0].lastName,
          "phoneNumber": user[0].phoneNumber,
          "email": user[0].email,
          "cardNumber": user[0].cardNumber,
          "participate": user[0].participate
        })
      }
    }

    JwtInterceptor
        .put(`${API_URL}Competitions/edition/${editionId}/prize/${data.user.service.id}`, putObj)
        .then((response) => {
          setSendLoader(false);
          setPrizesPopUp(false);
        })
        .catch(function (error) {
          setSendLoader(false);
          setSendErrorTxt(t('errDefault'));
          setSendError(true);
          if (error.response.status === 401) {
            logout();
          }
        });
  }

  const divideEquallyHandler = () => {
    if (totalPrize && totalPrize > 0 && watchedValues) {
      const allParticipate = getData.filter(p => p.participate);
      const prizePart = (totalPrize / allParticipate.length).toFixed(2).replace('.', ',');

      for (const key in watchedValues) {
        if (key.startsWith('prizeValue_')) {
          const userId = key.split('_')[1];
          const fieldName = `prizeValue_${userId}`;
          setValue(fieldName, prizePart);
        }
      }

      setSendError(false);
    }
  }

  if (getData && getData.length > 0) {
    fieldsets = getData.map((field, i) => {
      sum += field.prizeValue;
      return (
        <div  key={i}>
          {field.participate ?
            <div className="pb-3 border-solid border-b border-[#ebebeb]">
              <fieldset className="block w-full h-auto md:flex md:items-center md:h-[62px]">
                <label className="block w-full font-bold mt-2 mb-2 md:w-1/3 md:mb-0 md:mt-0">{field.firstName} {field.lastName}</label>
                <div className="flex w-full mb-2 md:w-2/3 md:flex md:items-center md:mb-0">
                  <div className="relative w-1/2 mr-3 md:w-1/2 md:ml-3 md:pr-0">
                    <input type="text" id={`prizePercent_${field.id}`} placeholder=" " defaultValue="" disabled={true} {...register(`prizePercent_${field.id}`)} maxLength="8" className="block w-full py-1.5 text-base outline-none border-b border-solid border-1 border-grayBorder2" />
                    <span className="absolute top-1 right-0 text-base">%</span>
                  </div>
                  <div className="relative w-1/2 ml-3 md:w-1/2 md:pr-0">
                    <input
                        type="text"
                        id={`prizeValue_${field.id}`}
                        placeholder=" "
                        defaultValue={field.prizeValue.toFixed(2).replace('.', ',')}
                        {...register(`prizeValue_${field.id}`, {
                          required: true,
                          pattern: /^[0-9.,]+$/i
                        })}
                        maxLength="8"
                        className="block w-full py-1.5 text-base outline-none border-b border-solid border-grayBorder2"
                    />
                    <span className="absolute top-1 right-0 text-base">zł</span>
                  </div>
                </div>
              </fieldset>
              {errors[`prizeValue_${field.id}`] && errors[`prizeValue_${field.id}`].type === "required" && <span className="block text-error text-right">{t('errFieldRequired')}</span>}
              {errors[`prizeValue_${field.id}`] && errors[`prizeValue_${field.id}`].type === "pattern" && <span className="block text-error text-right">{t('errFieldValue')}</span>}
            </div>
          :
            <fieldset className="flex items-center h-[62px] pb-3 border-solid border-b border-[#ebebeb]">
              <label className="relative top-4 w-1/3 font-bold text-grayBorder">{field.firstName} {field.lastName}</label>
              <div className="relative w-1/3 mx-6">
                <span className="block"></span>
                <span className="absolute top-1 right-0 text-grayBorder">%</span>
              </div>
              <div className="relative w-1/3">
                <span className="block"></span>
                <span className="absolute top-1 right-0 text-grayBorder">zł</span>
              </div>
            </fieldset>
          }
        </div>
      );
    });
  }

  return (
      <>
        <div className="fixed top-0 left-0 z-20 w-screen h-screen bg-popupOverlay"></div>
        <div className="fixed z-30 max-w-[600px] max-h-80vh overflow-y-auto top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-10/12 lg:w-1/2 bg-white md:text-xl terms">
          {error ?
            <>
              <p className="absolute top-6 right-6 transform -translate-y-1/2 font-bold text-base leading-[20px] border-solid border-[#efdf00] border-b-2 hover:cursor-pointer" onClick={() => setPrizesPopUp(false)}>{t('close')}</p>
              <p className="mt-8 p-4 text-error text-center">{t('errDefault')}</p>
            </>
          :
            <>
              <div className="relative w-full p-5 border-solid border-b border-[#ebebeb]">
                <p className="mb-1 font-bold text-sm leading-[24px] md:text-base md:leading-[28px]">{t('amountToBeDivided')}</p>
                <p className="font-bold text-xl leading-[30px] md:text-3xl md:leading-[45px]">{(totalPrize) ? totalPrize.toFixed(2).replace('.', ',') : ''} zł</p>
                <p className="absolute top-1/2 right-6 transform -translate-y-1/2 font-bold text-base leading-[20px] border-solid border-[#efdf00] border-b-2 hover:cursor-pointer" onClick={() => setPrizesPopUp(false)}>{t('close')}</p>
              </div>

              <form className="text-sm md:text-base px-5 py-3">
                {loader ? <LoaderBig styles="w-full h-[200px]" /> : fieldsets}
              </form>

              <div className="w-full mt-10 px-5 py-3 text-base border-solid border-t border-black">
                <div className="flex items-center justify-between mb-3">
                  <p className="text-base">{t('leftToBeDivided')}</p>
                  <p className={`flex items-center font-bold text-xl leading-[30px] md:text-3xl md:leading-[45px] ${totalPrize < totalSum ? 'text-[#e91630]' : 'text-[#72c293]'}`}>
                    {(totalPrize - totalSum).toFixed(2).replace('.', ',')} zł
                    {totalPrize < totalSum ?
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="ml-1">
                        <mask id="path-1-inside-1_1322_3642" fill="white">
                          <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"/>
                        </mask>
                        <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#E91630"/>
                        <path d="M12 24V22C6.47715 22 2 17.5228 2 12H0H-2C-2 19.732 4.26801 26 12 26V24ZM24 12H22C22 17.5228 17.5228 22 12 22V24V26C19.732 26 26 19.732 26 12H24ZM12 0V2C17.5228 2 22 6.47715 22 12H24H26C26 4.26801 19.732 -2 12 -2V0ZM12 0V-2C4.26801 -2 -2 4.26801 -2 12H0H2C2 6.47715 6.47715 2 12 2V0Z" fill="white" mask="url(#path-1-inside-1_1322_3642)"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M12.0001 9.87879L14.9395 6.93945L17.0608 9.06077L14.1214 12.0001L17.0608 14.9395L14.9395 17.0608L12.0001 14.1214L9.06077 17.0608L6.93945 14.9395L9.87879 12.0001L6.93945 9.06077L9.06077 6.93945L12.0001 9.87879Z" fill="white"/>
                      </svg>
                    :
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="ml-1">
                        <mask id="path-1-inside-1_1322_3637" fill="white">
                          <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"/>
                        </mask>
                        <path d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" fill="#72C293"/>
                        <path d="M12 24V22C6.47715 22 2 17.5228 2 12H0H-2C-2 19.732 4.26801 26 12 26V24ZM24 12H22C22 17.5228 17.5228 22 12 22V24V26C19.732 26 26 19.732 26 12H24ZM12 0V2C17.5228 2 22 6.47715 22 12H24H26C26 4.26801 19.732 -2 12 -2V0ZM12 0V-2C4.26801 -2 -2 4.26801 -2 12H0H2C2 6.47715 6.47715 2 12 2V0Z" fill="white" mask="url(#path-1-inside-1_1322_3637)"/>
                        <path fillRule="evenodd" clipRule="evenodd" d="M10.7826 12.5302L15.2783 8L17 9.73488L10.7826 16L7 12.1884L8.72167 10.4535L10.7826 12.5302Z" fill="white"/>
                      </svg>
                    }
                  </p>
                </div>
                {sendError && <p className="mt-8 p-4 text-error text-center">{sendErrorTxt ? sendErrorTxt : t('errDefault')}</p>}
                <div className="md:flex justify-between">
                  <Button anchor={t('divideEqually')} styles="mb-4 text-center md:w-1/2 md:mr-[6px] md:mb-0" onClickFnc={divideEquallyHandler} />
                  <Button anchor={t('approveTheDivision')} loading={sendLoader} icon={sendLoader} iconStyles="fill-white" onClickFnc={handleSubmit(onSubmit)} styles={`md:w-1/2 md:ml-[6px] bg-black text-white text-center hover:text-black ${disabledButton ? 'hover:cursor-default hover:text-white hover:bg-black hover:border-black' : ''}`} />
                </div>
              </div>
            </>
          }
        </div>
      </>
  );
}

export default CompetitionPrizeDivisionPopUp;